import React from 'react'
import { withTheme } from 'styled-components'

const Arrow = ({ theme }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
    >
      <path
        fill={theme.colors.buttonDefault}
        d="M29.25 20.85H14.288l5.73-4.73a.59.59 0 0 0 .025-.918.834.834 0 0 0-1.06-.023l-6.543 5.402c-.284.245-.44.572-.44.92 0 .346.156.673.453.93l6.53 5.39c.145.12.331.179.517.179a.808.808 0 0 0 .543-.202.59.59 0 0 0-.025-.919l-5.754-4.729H29.25c.414 0 .75-.291.75-.65 0-.359-.336-.65-.75-.65z"
      />
    </svg>
  )
}

export default withTheme(Arrow)
